/**
 * Image picker component for selecting and displaying photos
 * V3 Design - Uses text link style for "Add" button
 */
import { View, Pressable, Image, ActivityIndicator, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';

import CustomText from '../CustomText';
import AppStyles from '../../AppStyles';
import { useTranslation } from '../../i18n';

const MAX_IMAGES = 15;

const ImagePicker = ({
  images,
  imageLoading,
  onSelectPhoto,
  onRemovePhoto,
}) => {
  const { t } = useTranslation('common');

  return (
    <View style={styles.container}>
      {/* Photo thumbnails */}
      {images.length > 0 && (
        <View style={styles.photoRow}>
          {images.map((image, index) => (
            <View key={index} style={styles.photoWrapper}>
              <Image
                source={{ uri: image, priority: 'high' }}
                style={styles.photo}
                resizeMode="cover"
              />
              <Pressable
                style={styles.removeButton}
                onPress={() => onRemovePhoto(image)}
              >
                <Feather name="x" size={14} color="#fff" />
              </Pressable>
            </View>
          ))}
        </View>
      )}

      {/* Add photo link - V3 style */}
      {images.length < MAX_IMAGES && (
        <Pressable
          style={({ pressed }) => [styles.addLink, pressed && styles.addLinkPressed]}
          onPress={onSelectPhoto}
        >
          <View style={styles.addIcon}>
            <Feather name="image" size={16} color="#000" />
          </View>
          <CustomText font="medium" size={16} color="#000">
            {t('actions.add')}
          </CustomText>
          {imageLoading && <ActivityIndicator size="small" color={AppStyles.colorSet.brandPrimary} style={{ marginLeft: 8 }} />}
        </Pressable>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 12,
  },
  photoRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 8,
  },
  photoWrapper: {
    position: 'relative',
    marginRight: 8,
    marginBottom: 8,
  },
  photo: {
    height: 60,
    width: 60,
    borderRadius: 8,
  },
  removeButton: {
    position: 'absolute',
    top: -6,
    right: -6,
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addLink: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    cursor: 'pointer',
  },
  addLinkPressed: {
    opacity: 0.6,
  },
  addIcon: {
    width: 28,
    height: 28,
    borderRadius: 4,
    backgroundColor: AppStyles.colorSet.brandPrimary,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
});

export default ImagePicker;
